import {combineReducers} from 'redux';
import MergeReducer, {MergeState} from './MergeReducer';
import OrganizationReducer, {OrganizationState} from './OrganizationReducer';
import ProductMetaDataReducer, {ProductMetaDataState} from './ProductMetaDataReducer';
import UserFeedbackReducer, {UserFeedbackState} from './UserFeedbackReducer';
import SnackbarReducer, {SnackbarState} from './SnackbarReducer';
import UserReducer, {UserState} from './UserReducer';
import HighlightedProductsReducer, {HighlightedProductsState} from './HighlightedProductsReducer';

export interface ReducerActionAttributes<T, K> {
    type: T;
    value: K;
}

export interface GlobalApplicationState {
    highlightedProductsState: HighlightedProductsState;
    mergeState: MergeState;
    organizationState: OrganizationState;
    productMetaData: ProductMetaDataState;
    snackbar: SnackbarState;
    userFeedback: UserFeedbackState;
    userState: UserState;
}

const RootReducer = combineReducers({
    highlightedProductsState: HighlightedProductsReducer,
    mergeState: MergeReducer,
    organizationState: OrganizationReducer,
    productMetaData: ProductMetaDataReducer,
    snackbar: SnackbarReducer,
    userFeedback: UserFeedbackReducer,
    userState: UserReducer,
});

export type AppState = ReturnType<typeof RootReducer>;

export default RootReducer;
